import { render, staticRenderFns } from "./SportSpinningText.vue?vue&type=template&id=6cc77c33"
import script from "./SportSpinningText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportSpinningText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports